import React from "react";

const SandclockSVG = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6813 12.5748C15.6698 12.0357 16.6326 11.3755 17.4573 10.4911C18.8377 9.01068 19.7586 6.98585 19.9364 4.06669C20.0069 2.90758 19.063 2 17.9679 2H5.9679C4.88075 2 3.92123 2.89958 4.00512 4.07375C4.21634 7.02992 5.31358 9.01309 6.87435 10.4557C7.80287 11.314 8.88371 11.966 9.9688 12.5221C8.91833 12.993 7.86412 13.5297 6.96192 14.2329C5.38404 15.4628 4.24858 17.1992 4.01328 19.9138C3.90988 21.1066 4.88958 22 5.9679 22H17.9679C19.0464 22 20.0252 21.1068 19.9228 19.9147C19.7088 17.4221 18.745 15.6977 17.3689 14.4144C16.5664 13.6659 15.6342 13.0797 14.6813 12.5748ZM6.99427 6.44751L9.58877 9.63167C9.77868 9.86474 10.0634 10 10.364 10H13.636C13.9366 10 14.2213 9.86474 14.4112 9.63167L17.0057 6.44751C17.8042 5.46759 17.1069 4 15.8429 4H8.15712C6.89309 4 6.19582 5.46759 6.99427 6.44751Z"
        fill="white"
      />
    </svg>
  );
};

export default SandclockSVG;
